import React, { useEffect, useState } from "react";

import {

  ArrowUpRight,

  Clock3,

  CameraOff,

  IndianRupee,

  Waves,

  Mountain,

  Sparkles,

  ChevronDown,

  ChevronRight,

  Info,

} from "lucide-react";



import "./AzhimalaTempleSection.css";

import Rolling from "./Rolling";

import FeaturedVazhipads from "./FeaturedVazhipads";



const images = {

  hero:

    "https://media1.thrillophilia.com/filestore/8mhmqncrv1u02tpo19r0rfkm0cfv_download.jpg",



  statue:

    "https://cdn.ibcstack.com/article/bad24b2d-9231-40c8-9edf-8bceabfb61d2/25-68146b1856b98.webp",



  cave:

    "https://media.newindianexpress.com/newindianexpress/2025-08-27/yy1dta17/AZHIMALA3060307.JPG?auto=format%2Ccompress&w=1200",



  sunset:

    "https://cdn.ibcstack.com/article/f0f97ae0-4b01-4835-a9ab-bed371b2dabe/25-68146b18d9f1b.webp",

};



const highlights = [

  {

    number: "01",

    title: "Gangadhareshwara",

    description:

      "A majestic 58-foot Shiva sculpture rises dramatically above the rocky coastline.",

    icon: Mountain,

    image: images.statue,

  },

  {

    number: "02",

    title: "Cave Temple",

    description:

      "A subterranean spiritual space filled with intricate three-dimensional sculptures.",

    icon: Sparkles,

    image: images.cave,

  },

  {

    number: "03",

    title: "Arabian Sea",

    description:

      "Perched above the coast, the temple creates a spectacular meeting point of rock, sky and sea.",

    icon: Waves,

    image: images.sunset,

  },

];



const visitorInfo = [

  {

    icon: Clock3,

    label: "Temple Hours",

    value: "7:00 AM – 7:30 PM",

    detail: "Midday closure may apply",

  },

  {

    icon: IndianRupee,

    label: "Temple Entry",

    value: "Free",

    detail: "Cave museum: ₹100 / person",

  },

  {

    icon: CameraOff,

    label: "Photography",

    value: "Restricted",

    detail: "No photography inside sacred areas",

  },

];



function AzhimalaTempleSection() {

  const [activeHighlight, setActiveHighlight] = useState(0);

  const [showDetails, setShowDetails] = useState(false);

  // Keep alternating between Hindi and English every 4 seconds.
  const [heroLanguage, setHeroLanguage] = useState("hi");
  useEffect(() => {
    const timer = window.setInterval(() => {
      setHeroLanguage((current) => (current === "hi" ? "en" : "hi"));
    }, 4000);
    return () => window.clearInterval(timer);
  }, []);



  const active = highlights[activeHighlight];



  return (

    <section className="azh-section">

      {/* Background decorations */}

      <div className="azh-bg-orb azh-bg-orb-left" />

      <div className="azh-bg-orb azh-bg-orb-right" />



      {/* =====================================================

          HERO

      ===================================================== */}

      <div className="azh-container azh-hero-wrapper">

        <div className="azh-hero">

          <img

            src={images.hero}

            alt="Gangadhareshwara Shiva statue at Azhimala"

            className="azh-hero-image"

          />



          <div className="azh-hero-overlay" />

          <div className="azh-hero-bottom-overlay" />



          <div className="azh-location-pill">

            <span />

            AZHIMALA · KERALA

          </div>



          <div className="azh-hero-content">

            <div className="azh-hero-inner">

              <div className="azh-eyebrow azh-hero-eyebrow">

                <i />

                Where the sea meets the sacred

              </div>



              {/* Language entrance: Hindi first, then English. */}
            <div className="azh-language-stage">
              <div
                className={`azh-language-panel ${heroLanguage === "hi" ? "is-visible" : ""}`}
                lang="hi"
                aria-hidden={heroLanguage !== "hi"}
              >
                <h1>
                  अझिमला
                  <br />
                  <span>शिव मंदिर</span>
                </h1>
                <p style={{ fontSize: "20px" }}>
                  आझीमला शिव मंदिर...."एक नाटकीय तटीय धाम, जहाँ गंगाधरेश्वर की एक विशाल मूर्ति चट्टानों, पौराणिक कथाओं और शांत चिंतन से घिरी हुई अरब सागर की रखवाली करती है।"
                </p>
              </div>

              <div
                className={`azh-language-panel ${heroLanguage === "en" ? "is-visible" : ""}`}
                lang="en"
                aria-hidden={heroLanguage !== "en"}
              >
                <h1>
                  Azhimala
                  <br />
                  <span>Shiva Temple</span>
                </h1>
                <p>
                  A dramatic coastal sanctuary where a monumental
                  Gangadhareshwara sculpture watches over the Arabian Sea,
                  surrounded by rock, mythology and quiet contemplation.
                </p>
              </div>
            </div>

            <div className="azh-hero-actions">

                <a href="#azhimalahighlights" className="azh-btn azh-btn-gold">

                  Explore the temple

                  <ArrowUpRight size={17} />

                </a>



                <a

                  href="#visitor-info"

                  className="azh-btn azh-btn-glass"

                >

                  Visitor information

                </a>

              </div>

            </div>

          </div>



          <div className="azh-height-badge">

            <strong>58</strong>

            <span>FEET TALL</span>

            <small>SHIVA</small>

          </div>

        </div>

      </div>



      {/* =====================================================

          INTRO

      ===================================================== */}



      {/* <Rolling />

      <FeaturedVazhipads /> */}

      <div className="azh-container azh-intro">

        <div className="azh-intro-grid">

          <div>

            <div className="azh-eyebrow">

              A landmark by the Arabian Sea

            </div>



            <h2>

              Where monumental art meets{" "}

              <em>coastal stillness.</em>

            </h2>

          </div>



          <p className="azh-intro-text">

            The Azhimala temple complex is known for its striking

            Gangadhareshwara sculpture, its rocky coastal setting and its

            cave-like meditation spaces beneath the statue.

          </p>

        </div>



        <div className="azh-stats">

          <div className="azh-stat">

            <strong>

              58<small>ft</small>

            </strong>

            <span>Gangadhareshwara sculpture</span>

          </div>



          <div className="azh-stat">

            <strong>

              01<small>cave</small>

            </strong>

            <span>Meditation & sculpture space</span>

          </div>



          <div className="azh-stat">

            <strong>∞</strong>

            <span>Arabian Sea horizon</span>

          </div>

        </div>

      </div>



      {/* =====================================================

          INTERACTIVE HIGHLIGHTS

      ===================================================== */}

      <div

        id="azhimalahighlights"

        className="azh-container azh-highlights-wrapper"

      >

        <div className="azh-highlights">

          <div className="azh-highlight-menu">

            <div className="azh-eyebrow azh-gold-text">

              Discover

            </div>



            <h2>

              Three sides

              <br />

              of Azhimala

            </h2>



            <div className="azh-highlight-list">

              {highlights.map((item, index) => {

                const Icon = item.icon;

                const isActive = index === activeHighlight;



                return (

                  <button

                    key={item.title}

                    type="button"

                    className={`azh-highlight-item ${

                      isActive ? "active" : ""

                    }`}

                    onClick={() => setActiveHighlight(index)}

                  >

                    <span className="azh-highlight-number">

                      {item.number}

                    </span>



                    <Icon className="azh-highlight-icon" size={18} />



                    <span className="azh-highlight-title">

                      {item.title}

                    </span>



                    <ChevronRight

                      size={18}

                      className="azh-highlight-arrow"

                    />

                  </button>

                );

              })}

            </div>

          </div>



          <div className="azh-highlight-image">

            <img

              key={active.image}

              src={active.image}

              alt={active.title}

            />



            <div className="azh-highlight-image-overlay" />



            <div className="azh-highlight-caption">

              <span>{active.number}</span>



              <h3>{active.title}</h3>



              <p>{active.description}</p>

            </div>

          </div>

        </div>

      </div>



      {/* =====================================================

          MYTHOLOGY

      ===================================================== */}

      <div className="azh-container azh-mythology">

        <div className="azh-mythology-grid">

          <div className="azh-mythology-heading">

            <div className="azh-symbol">

              <Sparkles size={22} />

            </div>



            <div className="azh-eyebrow">

              Stories carved in stone

            </div>



            <h2>

              Mythology beneath

              <br />

              the mountain.

            </h2>

          </div>



          <div className="azh-mythology-copy">

            <div className="azh-gold-line" />



            <p className="azh-large-copy">

              Beneath the monumental sculpture is a cave-like meditation

              space featuring detailed three-dimensional representations

              from Hindu mythology.

            </p>



            <p>

              Local tradition also associates the natural caves of the area

              with the Pandavas of the Mahabharata. Such traditions form

              part of the cultural storytelling surrounding the site.

            </p>



            <div className="azh-info-note">

              <Info size={18} />



              <span>

                Mythological and local traditions are presented here as

                cultural beliefs rather than independently verified

                historical facts.

              </span>

            </div>

          </div>

        </div>

      </div>



      {/* =====================================================

          IMAGE GALLERY

      ===================================================== */}

      <div className="azh-container azh-gallery-wrapper">

        <div className="azh-gallery">

          <div className="azh-gallery-card azh-gallery-large">

            <img

              src={images.cave}

              alt="Cave sculpture at Azhimala"

            />



            <div className="azh-gallery-overlay" />



            <div className="azh-gallery-caption">

              <span>UNDERGROUND SANCTUARY</span>

              <h3>The Cave Temple</h3>

            </div>

          </div>



          <div className="azh-gallery-card">

            <img

              src={images.statue}

              alt="Gangadhareshwara statue"

            />



            <div className="azh-gallery-overlay" />



            <div className="azh-gallery-caption">

              <span>58 FEET</span>

              <h3>Gangadhareshwara</h3>

            </div>

          </div>



          <div className="azh-gallery-card">

            <img

              src={images.sunset}

              alt="Azhimala coastline at sunset"

            />



            <div className="azh-gallery-overlay" />



            <div className="azh-gallery-caption">

              <span>COASTAL VIEWS</span>

              <h3>Arabian Sea</h3>

            </div>

          </div>

        </div>

      </div>



      {/* =====================================================

          VISITOR INFO

      ===================================================== */}

      <div

        id="visitor-info"

        className="azh-container azh-visitor"

      >

        <div className="azh-visitor-heading">

          <div>

            <div className="azh-eyebrow">

              Plan your visit

            </div>



            <h2>Before you go</h2>

          </div>



          <p>

            Visitor rules and timings can change. Treat the following

            as planning information and confirm locally before your visit.

          </p>

        </div>



        <div className="azh-visitor-grid">

          {visitorInfo.map((item) => {

            const Icon = item.icon;



            return (

              <div className="azh-visitor-card" key={item.label}>

                <div className="azh-visitor-card-top">

                  <div className="azh-visitor-icon">

                    <Icon size={19} />

                  </div>



                  <ArrowUpRight size={18} />

                </div>



                <div className="azh-card-label">

                  {item.label}

                </div>



                <h3>{item.value}</h3>



                <p>{item.detail}</p>

              </div>

            );

          })}

        </div>



        {/* Accordion */}

        <div className="azh-accordion">

          <button

            type="button"

            className="azh-accordion-button"

            onClick={() => setShowDetails(!showDetails)}

          >

            <div>

              <div className="azh-card-label">

                Sacred-space etiquette

              </div>



              <h3>Know before entering</h3>

            </div>



            <span

              className={`azh-accordion-icon ${

                showDetails ? "open" : ""

              }`}

            >

              <ChevronDown size={18} />

            </span>

          </button>



          <div

            className={`azh-accordion-content ${

              showDetails ? "open" : ""

            }`}

          >

            <div className="azh-rules-grid">

              <div className="azh-rule">

                <CameraOff size={18} />



                <h4>Photography</h4>



                <p>

                  Photography and mobile phones may be restricted inside

                  the cave and sanctum.

                </p>

              </div>



              <div className="azh-rule">

                <Sparkles size={18} />



                <h4>Dress respectfully</h4>



                <p>

                  Follow the temple's dress requirements when entering

                  sacred areas.

                </p>

              </div>



              <div className="azh-rule">

                <Clock3 size={18} />



                <h4>Check timings</h4>



                <p>

                  Opening hours can vary, especially around rituals

                  and festivals.

                </p>

              </div>

            </div>

          </div>

        </div>

      </div>



      {/* =====================================================

          CTA

      ===================================================== */}

      <div className="azh-container azh-cta-wrapper">

        <div className="azh-cta">

          <div className="azh-cta-circle azh-cta-circle-one" />

          <div className="azh-cta-circle azh-cta-circle-two" />



          <div className="azh-cta-content">

            <div>

              <div className="azh-cta-eyebrow">

                A place to pause

              </div>



              <h2>

                Come for the statue.

                <br />

                Stay for the horizon.

              </h2>

            </div>



            <a

              href="#visitor-info"

              className="azh-cta-button"

            >

              Plan your visit

              <ArrowUpRight size={17} />

            </a>

          </div>

        </div>

      </div>

    </section>

  );

}



export default AzhimalaTempleSection;